import React from 'react';
import clsx from 'clsx';

import { withStyles } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';

import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    overflow: 'hidden',
    padding: theme.spacing(2, 1),
  },
  avatar: {
    margin: theme.spacing(1,0),
    color: theme.palette.getContrastText(grey[300]),
    backgroundColor: grey[300],
  },
  small: {
    width: theme.spacing(3.9),
    height: theme.spacing(3.9),
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
});
const GridAvatar = React.memo(({ classes, size='medium', image, name, children }) => {
  return (
    <div className={classes.root}>
      <Grid container wrap="nowrap" spacing={2}>
        <Grid item>
          <Avatar src={image} className={clsx(classes.avatar, {
                [classes.small]: size==='small',
                [classes.large]: size==='large',
              })}>
            { (!image && name) && name}
            { !image && !name && <PersonOutlineOutlinedIcon />}
          </Avatar>
        </Grid>
        <Grid item xs zeroMinWidth>
          {children}
        </Grid>
      </Grid>
    </div>
  );
});

export default  withStyles(styles)(GridAvatar);
